export default __webpack_public_path__ + "static/media/O-134.e077ed0c.png";